import { vars } from "@common/styles";
import styled, { css } from "styled-components";

export const CrashEventNavigationButton = styled.button`
  outline: none;
  border: none;
  background: none;
  width: 2.4rem;
  height: 2.4rem;

  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const CrashNavigation = styled.div`
  display: flex;
  margin-left: 5rem;
`;

export const CrashNavigationLinks = styled.a<{
  $active?: boolean;
}>`
  margin: 0 1rem;
  color: ${vars.colors.grey70};
  font-weight: normal;
  &:hover,
  &:focus,
  &:active {
    color: ${vars.colors.grey20};
    border-bottom: 0.1rem dashed ${vars.colors.grey20};
    text-decoration: none;
  }
  ${(props) =>
    props.$active &&
    css`
      color: ${vars.colors.grey20};
      border-bottom: 0.1rem dashed ${vars.colors.grey20};
      text-decoration: none;
    `}
`;
